import { Button, FilterCommon, HistoryModal, Table } from "@/components";
import {
  CREATE_TYPE,
  filtersJson,
  GENERAL_CONFIGURATION,
  handleMessagesAPI,
  HISTORY_TYPE,
  PAGINATION_DEFAULT,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
} from "@/utils";
import moment from "moment";
import { mapState } from "vuex";
import { actions, generalConfigColumns } from "../../constants";
import GeneralConfigurationModal from "./GeneralConfigurationModal/GeneralConfigurationModal.vue";

export default {
  name: "GeneralConfiguration",
  props: {},
  components: {
    FilterCommon,
    Table,
    Button,
    GeneralConfigurationModal,
    HistoryModal,
  },
  data() {
    return {
      columns: generalConfigColumns,
      actions,
      GENERAL_CONFIGURATION,
      visibleModal: false,
      visibleModalHistory: false,
      formData: {},
      page: 1,
      size: 10,
      total: 0,
      filter: PAGINATION_DEFAULT,
      dataFilterDefault: {},
      sort: { direction: -1 },
      filterList: filtersJson[GENERAL_CONFIGURATION],
      fetching: false,
      type: null,
      recordActive: {},
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.loading,
      generalConfigs: (state) => state.generalConfiguration.generalConfigList,
      historyGeneralConfigList: (state) => state.generalConfiguration.historyGeneralConfigList,
      userInfo: (state) => state.user.userInfo,
      pages: (state) => state.generalConfiguration.pages,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  watch: {
    filter() {
      this.getGeneralConfigs();
    },
  },
  created() {
    this.getGeneralConfigs();
  },
  methods: {
    /**
     * Handle action click icon in table
     */
    async onAction({ type, data }) {
      this.type = type;
      this.recordActive = data;
      switch (type) {
        case HISTORY_TYPE:
          this.$store.dispatch("user/loadingRequest");
          try {
            await this.$store.dispatch("generalConfiguration/historyGeneralConfigList", { id: data?.id });
          } finally {
            this.$store.commit("user/RESET_LOADING");
            this.visibleModalHistory = true;
          }
          break;
        default:
          this.visibleModal = true;
      }
    },

    handleFilter(filter) {
      const { applyFromDate, applyToDate, expireFromDate, expireToDate } = filter;
      !applyFromDate && delete this.filter?.applyFromDate;
      !applyToDate && delete this.filter?.applyToDate;
      !expireFromDate && delete this.filter?.expireFromDate;
      !expireToDate && delete this.filter?.expireToDate;

      this.filter.page = 1;
      this.filter = { ...this.filter, ...filter };
    },

    handleResetFilter() {},

    showModal(conditionField, newData) {
      this.visibleModal[conditionField] = true;

      if (newData) {
        this.formData = newData;
      }
    },

    handleOk(conditionField, refForm = "") {
      this.fetching = true;
      const callback = (success = true, isEdit = null) => {
        if (success) {
          this.visibleModal[conditionField] = false;
          if (isEdit != null && isEdit == false) {
            this.filter.page = 1;
          }
          this.getGeneralConfigs();
        }

        this.fetching = false;
      };

      // delete item
      if (!refForm) {
        this.handleRemoveItem(this.formData, callback);
      } else {
        this.$refs[refForm].handleOk(callback);
      }
    },

    handleCancel(conditionField) {
      this.visibleModal[conditionField] = false;
    },

    initGeneralConfiguration() {
      return {
        seniorityLeaveDay: "",
        seniorityLeaveYear: "",
        conditionalMonth: "",
        leaveDayInMonth: "",
        advanceLeave: "",
        applyDate: null,
        expireDate: null,
      };
    },

    /**
     * Delete item in table list
     * @param {*} record item
     */
    handleRemoveItem(record, callback) {
      this.deleteGeneralConfig(record, callback);
    },

    handleAddNew() {
      this.type = CREATE_TYPE;
      this.visibleModal = true;
    },

    editItem(record) {
      record = {
        ...record,
        applyDate: moment(record.applyDate, "DD/MM/YYYY"),
        expireDate: moment(record.expireDate, "DD/MM/YYYY"),
      };
      this.showModal("edit", record);
    },

    removeItem(record) {
      this.showModal("delete", record);
    },
    getGeneralConfigs() {
      this.$store.dispatch("user/loadingRequest");
      const { sort, filter } = this;
      this.$store
        .dispatch("generalConfiguration/getGeneralConfigList", { ...filter, ...sort })
        .then((res) => {
          if (res.data) {
            this.total = res.page.total_element;
          }
        })
        .catch((error) => {
          handleMessagesAPI(error.response.data);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },

    deleteGeneralConfig(record, callback) {
      this.$store
        .dispatch("generalConfiguration/deleteGeneralConfig", record.id)
        .then((res) => {
          handleMessagesAPI(res);
          const { code } = res;
          if (code == 200) {
            if (this.generalConfigs.length == 1) {
              this.filter.page--;
            }
            callback();
          }
        })
        .catch((error) => {
          handleMessagesAPI(error.response.data);
          this.fetching = false;
        });
    },

    onChangePage(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    onCancel(isSaveRecordSuccess) {
      this.visibleModal = false;
      this.visibleModalHistory = false;
      this.type = null;
      if (isSaveRecordSuccess) {
        this.getGeneralConfigs();
      }
    },
  },
  mounted() {},
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
